RivalIQ.apps.Favorites.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const ColumnWidthMixin = {
        afterConstruction: function () {
            const me = this;
            me.listenTo(me.dashboardModel, 'change:columnWidth', me.updateWrapper);
        },

        onAttach: function () {
            const me = this;
            me.toggleColumnWidthClasses();
        },

        toggleColumnWidthClasses: function () {
            const me = this;
            const columnWidth = me.getProp('columnWidth');
            const classNames = 'col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1';
            me.$el.parent().toggleClass(classNames, (columnWidth === 6));
        },

        updateWrapper: function () {
            const me = this;
            me.toggleColumnWidthClasses();
            me.showBody();
        }
    };

    const Widgets = RivalIQ.apps.Dashboard.views.Widgets.extend({
        getPanelView: function (child) {
            const definition = {
                mixins: [ColumnWidthMixin]
            };

            if (child.panelView) {
                return child.panelView.mixin(definition);
            }

            return RivalIQ.apps.Dashboard.views.Panel.mixin(definition);
        }
    });

    function fireWidgetSavedEvent(widget, trackingEventType) {
        const eventProps = {
            chart: widget.toJSON()
        };
        const chartProps = eventProps.chart.props;
        if (chartProps.primaryDimension) {
            eventProps.primaryDimension = chartProps.primaryDimension;
            eventProps.isDimensionFiltered = Boolean(chartProps.primaryDimension === 'companySetId' && chartProps.onlyCompanySetIds);
        }
        RivalIQ.execute('tracking:push:auth', trackingEventType, eventProps);
    }

    views.Layout = RivalIQ.views.LayoutView.mixin({
        template: '#favoritesLayoutTemplate',

        ui: {
            save: '.x-save',
            update: '.x-update'
        },

        regions: {
            builder: '.x-builder-region',
            widget: '.x-widget-region'
        },

        events: {
            'click @ui.save': 'onSaveClick',
            'click @ui.update': 'onUpdateClick'
        },

        behaviors: {
            Localizable: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'setSaveDisabledStatus'
        },

        getBackPath: function () {
            const me = this;
            const configurationId = me.getProp('configurationId');
            return ['/dashboards', configurationId].join('/');
        },

        serializeData: function () {
            const me = this;
            return _.defaults(me.dashboardModel.getProps(), {
                name: me.dashboardModel.title(),
                focusWidgetInstanceId: undefined,
                backPath: me.getBackPath()
            });
        },

        templateHelpers: function () {
            return {
                getTitle: function () {
                    return 'Chart';
                }
            };
        },

        onAttach: function () {
            const me = this;
            me.initializePopovers();
        },

        onBeforeShow: function () {
            const me = this;

            me.builder.show(new views.Builder({
                collection: me.collection,
                dashboardModel: me.dashboardModel
            }));

            me.widget.show(new Widgets({
                collection: me.collection,
                dashboardModel: me.dashboardModel
            }), {
                forceLoadingView: true
            });

            me.setSaveDisabledStatus();
        },

        setSaveDisabledStatus: function () {
            const me = this;

            const widget = me.dashboardModel.getWidget();
            const widgetGroupId = widget.widgetGroupId;

            me.isAtWidgetGroupLimit(widgetGroupId)
                .done(function (isAtLimit) {
                    const updateAttrs = {
                        disabled: widget.isRestricted()
                    };

                    // NOTE clone is important; we don't want to extend
                    // `updateAttrs`, as they should only be adjusted by widget
                    // restriction, not type limits
                    const saveAttrs = _.clone(updateAttrs);

                    if (isAtLimit) {
                        _.extend(saveAttrs, {
                            disabled: true,
                            'data-toggle': 'tooltip',
                            'data-placement': 'left',
                            style: 'pointer-events: auto;',
                            title: RivalIQ.str('dashboards_curation_widgets_type_limit', me.getWidgetGroupLimit(widgetGroupId), widgetGroupId)
                        });
                    }

                    me.ui.save.attr(saveAttrs).tooltip();
                    me.ui.update.attr(updateAttrs);
                });
        },

        getWidgetGroupLimits: function () {
            const limits = {};
            limits[RivalIQ.enums.widgetGroupType.LIST] = RivalIQ.state.product.get('customDashboardsListsWidgetLimit');
            limits[RivalIQ.enums.widgetGroupType.INSTAGRAM_INSIGHTS_POSTS] = RivalIQ.state.product.get('customDashboardsListsWidgetLimit');
            limits[RivalIQ.enums.widgetGroupType.INSTAGRAM_INSIGHTS_STORIES] = RivalIQ.state.product.get('customDashboardsListsWidgetLimit');
            limits[RivalIQ.enums.widgetGroupType.INSTAGRAM_INSIGHTS_STORYDAYS] = RivalIQ.state.product.get('customDashboardsListsWidgetLimit');
            return limits;
        },

        getWidgetGroupLimit: function (widgetGroupId) {
            const me = this;
            const limits = me.getWidgetGroupLimits();
            return _.get(limits, widgetGroupId);
        },

        isAtWidgetGroupLimit: function (widgetGroupId) {
            const me = this;

            const limit = me.getWidgetGroupLimit(widgetGroupId);
            if (!_.isFinite(limit)) {
                return (new $.Deferred()).resolve();
            }

            const props = me.getProps();
            // NOTE we need to retrieve the parent curation configuration
            // (i.e., the Custom Dashboard where this widget lives, or will
            // live) in order to determine if we are at a limit (because we
            // need the widget definitions, which we won't have on hand).
            const curation = new RivalIQ.apps.Analyze.curations.Favorites(null, {
                curation_id: RivalIQ.enums.curation.DASHBOARDS
            });
            curation.reset(_.pick(props, 'configurationId', 'landscapeId'));

            // NOTE we use the configuration cache to try to alleviate the pain
            // of making a network call to disable a button
            return RivalIQ.data.configuration.fetch(curation, props)
                .then(function (configuration) {
                    const chartTypes = RivalIQ.apps.Favorites.data.chartTypes;

                    const definitions = configuration.get('definitions');
                    const count = _.reduce(definitions, function (memo, definition) {
                        const chartType = chartTypes[definition.widgetId];
                        return (chartType && chartType.widgetGroupId === widgetGroupId ? memo + 1 : memo);
                    }, 0);

                    return (count >= limit);
                });
        },

        getFavoritesPath: function () {
            const me = this;
            return `/dashboards/${me.getProp('configurationId')}`;
        },

        onSaveClick: function () {
            const me = this;
            const widget = me.dashboardModel.getWidget();
            widget.instanceId = undefined;

            me.ui.save.button('loading');

            me.dashboardModel.appendDefinition(widget)
                .fail(function () {
                    RivalIQ.execute('alert:warning', 'An error occurred saving this graph, please try again');
                    me.requestRenderedFrame(() => me.ui.save.button('reset'));
                })
                .done(function () {
                    fireWidgetSavedEvent(widget, RivalIQ.tracking.metric.FavoritesChartSave);
                    RivalIQ.execute('history:navigate', me.getFavoritesPath(), {
                        trigger: true
                    });
                });
        },

        onUpdateClick: function () {
            const me = this;
            const widget = me.dashboardModel.getWidget();

            me.ui.update.button('loading');

            const titleProps = _.reduce(['title', 'focusCompanyTitlePlacement'], (memo, titleProp) => {
                memo[titleProp] = widget.get(titleProp);
                return memo;
            }, {});

            widget.save(titleProps)
                .fail(function () {
                    RivalIQ.execute('alert:warning', 'An error occurred updating this graph, please try again');
                    me.requestRenderedFrame(() => me.ui.update.button('reset'));
                })
                .done(function () {
                    fireWidgetSavedEvent(widget, RivalIQ.tracking.metric.FavoritesChartUpdate);
                    RivalIQ.execute('history:navigate', me.getFavoritesPath(), {
                        trigger: true
                    });
                });
        },

        initializePopovers: function () {
            const me = this;
            me.$('[data-toggle="popover"]').popover({
                html: true,
                trigger: 'hover',
                placement: 'auto',
                container: 'body'
            });
        }
    });

});
